// @ts-check

import { action, makeAutoObservable } from "mobx";
import UsersRequests from "Utils/Requests/UsersRequests";
import AppStore from "./AppStore";
import Helper from "Utils/Helper";

class DeviceTracesStore {
    static UNKNOWN_KEYS_REGEXP = /^[a-zA-Z0-9.;]+$/;

    /** @type {DeviceTraceKeysInfo | null} */
    traceInfo;
    /** @type {DeviceTraceKeysInfo | null} */
    initialTraceInfo;
    loaded;

    constructor() {
        makeAutoObservable(this);

        this.traceInfo = null;
        this.initialTraceInfo = null;
        this.loaded = false;
    }

    get unknownKeysInvalid() {
        if (!this.traceInfo?.unknownTraceKeys)
            return false;

        return !DeviceTracesStore.UNKNOWN_KEYS_REGEXP.test(this.traceInfo.unknownTraceKeys);
    }

    get clearTracesAvailable() {
        return this.traceInfo?.hasTraces ?? false;
    }

    GetTracesChanged() {
        if (!this.traceInfo || !this.initialTraceInfo)
            return false;

        if (this.traceInfo.unknownTraceKeys != this.initialTraceInfo.unknownTraceKeys)
            return true;

        if (JSON.stringify(this.traceInfo.knownTraceKeys) != JSON.stringify(this.initialTraceInfo.knownTraceKeys))
            return true;

        return false;
    }

    /**
     * @param {number | null} deviceId
     */
    LoadTraceInfo(deviceId) {
        if (!deviceId) {
            this.traceInfo = null;
            this.loaded = true;
            return;
        }

        this.loaded = false;

        UsersRequests.GetDeviceTraceKeys(deviceId)
            .then(action(result => {
                if (result.error) {
                    this.traceInfo = null;
                    return;
                }

                this.traceInfo = result.value;
                this.initialTraceInfo = Helper.CloneObject(result.value);
                AppStore.pageTitleAdditionalInfo = ` ${result.value.userName} - ${result.value.userDepartment}`;
            }))
            .finally(action(() => this.loaded = true));
    }

    UnloadTraceInfo() {
        this.loaded = false;
        this.traceInfo = null;
    }

    SaveTraceInfo() {
        if (!this.traceInfo)
            return;

        this.loaded = false;

        UsersRequests.SetDeviceTraceKeys(this.traceInfo)
            .then(action(result => {
                if (result.error) {
                    this.traceInfo = null;
                    return;
                }

                this.traceInfo = result.value;
                this.initialTraceInfo = Helper.CloneObject(result.value);
                AppStore.pageTitleAdditionalInfo = ` ${result.value.userName} - ${result.value.userDepartment}`;
            }))
            .finally(action(() => this.loaded = true));
    }

    ClearDeviceTraces() {
        if (!this.traceInfo)
            return;

        this.loaded = false;

        UsersRequests.ClearDeviceTraces(this.traceInfo.deviceId)
            .then(action(result => {
                if (result.error)
                    return;

                if (this.traceInfo)
                    this.traceInfo.hasTraces = result.value;
                if (this.initialTraceInfo)
                    this.initialTraceInfo.hasTraces = result.value;
            }))
            .finally(action(() => this.loaded = true));
    }
}

export default new DeviceTracesStore;